var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinUnselected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 12.2487L4.66667 9.33203",
    stroke: "#1E1F26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73445 11.0083C5.55083 10.5125 3.48775 8.44947 2.99197 6.26588C2.91349 5.92019 2.87425 5.74739 2.98793 5.46698C3.10162 5.18659 3.24049 5.09982 3.51824 4.9263C4.1461 4.53405 4.82597 4.40935 5.53154 4.47175C6.52158 4.55932 7.0166 4.60311 7.26352 4.47445C7.51051 4.34578 7.67827 4.04493 8.01392 3.44324L8.43906 2.68102C8.71912 2.17891 8.85917 1.92786 9.18858 1.80951C9.51799 1.69116 9.71621 1.76283 10.1127 1.90616C11.0399 2.24138 11.7589 2.96045 12.0942 3.88762C12.2375 4.2841 12.3092 4.48234 12.1908 4.81174C12.0725 5.14115 11.8214 5.28119 11.3193 5.56126L10.5395 5.9962C9.93892 6.33115 9.63868 6.49868 9.51006 6.748C9.38143 6.99738 9.42816 7.4816 9.52155 8.45011C9.59027 9.1623 9.47185 9.84667 9.07437 10.4823C8.90065 10.7601 8.81379 10.8989 8.5335 11.0125C8.25315 11.1261 8.08025 11.0868 7.73445 11.0083Z",
    stroke: "#1E1F26",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinUnselected);
export default __webpack_public_path__ + "static/media/Pin_unselected.8a1c0e4964dfc64efd555faa8ba0f74a.svg";
export { ForwardRef as ReactComponent };